import React from 'react';
import PropTypes from 'prop-types';
import AttendeeReviewFormContainer from '../app-main/components/reduxForms/forms/AttendeeReviewForm/AttendeeReviewFormContainer';
import whiteBackground from '../wrapper-components/white-background';
import EventDetailCard from './EventDetailCard';
import { get } from 'lodash';

const AttendeeReviewPage = ({ reviewId, review }) => {
  const booking = get(review, 'booking');
  const guestFirstName = get(review, 'guest.name.first');
  const listingImageExternalId = get(review, 'listing.images[0].external_id');

  return (
    <div className="AttendeeReviewPage flex center">
      <div className="container-small">
        <h2>How was the venue?</h2>

        <EventDetailCard
          booking={booking}
          guestFirstName={guestFirstName}
          listingImageExternalId={listingImageExternalId}
        />

        <AttendeeReviewFormContainer
          className="flex"
          reviewId={reviewId}
        />
      </div>
    </div>
  );
}

AttendeeReviewPage.propTypes = {
  reviewId: PropTypes.string,
  review: PropTypes.object
};

export default whiteBackground(AttendeeReviewPage);
